import moment from 'moment';
import DetailsTable, { DetailsRow } from '../../common/details-table';
import { Match } from './utils/data';
import { useStringsContext } from '../../../contexts/strings';

export default function MatchDetails({ matchDoc }: { matchDoc: Match }) {
  const { strings } = useStringsContext();
  const details = [
    {
      label: strings.matches.league,
      value: matchDoc.leagueName,
    },
    {
      label: strings.matches.season,
      value: matchDoc.round,
    },
    {
      label: strings.matches.startDate,
      value: moment(matchDoc.startDate).format('YYYY-MM-DD HH:mm'),
    },
    {
      label: strings.matches.homeTeam,
      value: matchDoc.homeTeamName,
    },
    {
      label: strings.matches.visitingTeam,
      value: matchDoc.visitingTeamName,
    },
    {
      label: strings.matches.result,
      value: `${matchDoc.homeTeamScore} - ${matchDoc.visitingTeamScore}`,
    },
    {
      label: strings.matches.status,
      value: matchDoc.status,
    },
    {
      label: strings.matches.arena,
      value: matchDoc.arenaName,
    },
    {
      label: strings.matches.spectators,
      value: matchDoc.spectators,
    },
    {
      label: strings.matches.referee,
      value: matchDoc.referees?.join(', '),
    },
    {
      label: strings.matches.matchId,
      value: matchDoc.id,
    },
    {
      label: strings.matches.fogisId,
      value: matchDoc.fogisId,
    },
    {
      label: strings.matches.public,
      value: matchDoc.isAvailablePublicly ? strings.actions.yes : strings.actions.no,
    },
  ] satisfies DetailsRow[];

  return <DetailsTable rows={details} />;
}
